// You can find the IDs for our fathom goals in the settings within
// the fathom admin UI.
export const GOALS = {
  CLICK_MAILTO_LINK: 'GFWJIGNL',
  SHOW_CONTACT_FORM: '5O1II0EM',
  CLOSE_CONTACT_FORM: 'EC6JPEQD',
  CHOOSE_CONTACT_FORM_CATEGORY: 'LE6LZLPX',
  SUBMIT_CONTACT_FORM: 'MEPHXJNZ',
  CLICK_INSTAGRAM_LINK: '54HQ9VVV',
  CLICK_TWITTER_LINK: 'TUAITRZ6',
  CLICK_GITHUB_LINK: 'SWDXOZCH',
  CLICK_LINKEDIN_LINK: 'XYDTW9IU'
};

export const trackGoal = (code, value = 0) => {
  if (typeof window?.fathom?.trackGoal === 'function') {
    window.fathom.trackGoal(code, value);
  }
};
